var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentRole !== 'student' && _vm.currentRole !== 'educator')?_c('pcg-btn',{staticClass:"prk-button",attrs:{"round":"","icon":_vm.iconRemove,"text":"delete_syllabus","variant":"danger"},on:{"click":_vm.removeSyllabus}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }